import {
  arrayRemove,
  arrayUnion,
  doc,
  getFirestore,
  updateDoc,
} from 'firebase/firestore';
import { getUserId } from './firebaseInit';

const updateVote = async (
  retrospectiveId: string,
  cardId: string,
  isIncrease: boolean
) => {
  const documentReference = doc(
    getFirestore(),
    'retrospectives',
    retrospectiveId,
    'cards',
    cardId
  );
  await updateDoc(documentReference, {
    votes: isIncrease ? arrayUnion(getUserId()) : arrayRemove(getUserId()),
  });
};

const increaseVote = async (retrospectiveId, cardId) => {
  await updateVote(retrospectiveId, cardId, true);
};

const decreaseVote = async (retrospectiveId, cardId) => {
  await updateVote(retrospectiveId, cardId, false);
};

export { increaseVote, decreaseVote };
